export default __webpack_public_path__ + "static/media/cherry-online-service.07215af7.png";